import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

// customer bulkupload
export const fetchLogFiles = () => {
  return apiClient(ENDPOINTS.LOGS.FILES, { method: "GET" });
};

// Fetch single log file by name
export const fetchLogFileByName = (fileName) => {
  return apiClient(ENDPOINTS.LOGS.FILE_BY_NAME(fileName), {
    method: "GET",
  });
};

export const customerBulkUploadService = {
  uploadCustomerBulk: async (file, type, onProgress) => {
    const formData = new FormData();
    formData.append("file", file);
    return apiClient(ENDPOINTS.CUSTOMER_BULK_UPLOAD, {
      method: "POST",
      body: formData,
      requiresAuth: true,
    });
  },
};


// dispute bulkupload

export const fetchdisputeLogFiles = () => {
  return apiClient(ENDPOINTS.DISPUTE_LOGS.FILES, { method: "GET" });
};

// Fetch single dispute log file by name
export const fetchdisputeLogFileByName = (fileName) => {
  return apiClient(ENDPOINTS.LOGS.FILE_BY_NAME(fileName), {
    method: "GET",
  });
};

export const DisputeBulkUploadService = {
  uploadDisputeBulk: async (file, type, onProgress) => {
    const formData = new FormData();
    formData.append("file", file);
    return apiClient(ENDPOINTS.USER_BULK_UPLOAD_DISPUTE, {
      method: "POST",
      body: formData,
      requiresAuth: true,
    });
  },
};


